// 指定长度的随机字符串
let randomString = (len = 32) => {
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

export default {
  // 文件随机改名 原/var/test.png -> /var/test_rand(6).png
  getRandFilename(filename) {
    let pos = filename.lastIndexOf('.')
    let file = filename
    // 没有最后一个.
    if (pos !== -1) {
      file = randomString() + filename.substring(pos)
    } else {
      file = randomString()
    }
    file = 'files/' + new Date().getFullYear() + '/' + (new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1) + '/' + file
    return file
  }
}
